// Reconstructed from production code; original paths and local names were not available.
import "./styles/production.css";
import "./styles/localization.css";
import { App } from "./App.jsx";
import { AuthProvider } from "./context/AuthContext.jsx";
import { BrowserRouter } from "react-router-dom";
import { CartProvider } from "./context/CartContext.jsx";
import { FiltersProvider } from "./context/FiltersContext.jsx";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext.jsx";
import * as ReactDOM from "react-dom/client";
import ReactDefault from "react";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import * as jsxRuntime from "react/jsx-runtime";
ReactDOM.createRoot(document.getElementById("root")).render(
  <ReactDefault.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <LanguageProvider>
              <FiltersProvider>
                <CartProvider>
                  <App />
                </CartProvider>
              </FiltersProvider>
            </LanguageProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </ReactDefault.StrictMode>,
);
